import React from 'react'
import {Stack, Flex} from '../../vanilla'
import {SlotComponent} from '../../types/ui'
import {flyoutGrid} from './styles.css'
import {CmsImage} from './cms-image'
import { NavFlyoutCmsContent } from '../../types/cms/navigation'


export const NavFlyoutGrid: SlotComponent<NavFlyoutCmsContent> = ({content}) => {
  const imagesList = content?.listItems

  return (
    <Stack spacing="4px">
      <Flex
        alignItems="stretch"
        flexWrap="wrap"
        gap={['12px', '28px']}
        bg="white"
        paddingY={['16px', '20px']}
      >
        {imagesList?.map(({image, imageLink}) => {
          return (
            <CmsImage
              images={image.images}
              width="full"
              height="auto"
              imageLink={imageLink}
              linkProps={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                className: flyoutGrid,
              }}
              key={imageLink}
            />
          )
        })}
      </Flex>
    </Stack>
  )
}
